import { render } from "./realNameSuccess.vue?vue&type=template&id=1582da06&scoped=true"
import script from "./realNameSuccess.vue?vue&type=script&lang=js"
export * from "./realNameSuccess.vue?vue&type=script&lang=js"

import "./realNameSuccess.vue?vue&type=style&index=0&id=1582da06&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_ZubV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1582da06"]])

export default __exports__